import { challanApiUrl } from '@/constants/urls'
import { getFFUserType } from '@/utils'
import { createAxiosClient } from './axiosClient'

export const api = createAxiosClient(challanApiUrl())

export const userTypeHeader = () => ({ 'user-type': getFFUserType() })

export const encodeQueryValue = (value: string) => encodeURIComponent(value)

export const buildQuery = (params: Record<string, unknown> = {}) => {
  const query = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      query.set(key, String(value))
    }
  })
  return query.toString() ? `?${query.toString()}` : ''
}
